// extracted by mini-css-extract-plugin
export default {"root":"OrB9nLfRwG","row":"uj77JgNFU1"};